/* 會員相關接口 */

import request from '@/utils/http/request'



//List
export async function fetchAll({ username, pageSize, page }) {
    return await request.post('/administrator', {
        username, pageSize, page
    }, {
        noAuth: false
    });
}

export async function fetch(id) {
    return await request.post(`/administrator/show`, { id });
}

export async function store({ name, password, username }) {
    return await request.post('/administrator/store', {
        name, password, username
    });
}

export async function update({ id, username, name, password }) {
    return await request.post(`/administrator/update`, {
        id, username, name, password
    });
}
export async function destroy(id) {
    return await request.post(`/administrator/destroy`, { id });
}

